<template>
  <b-row class="menu no-gutters">
    <b-col class="tool-border" cols="12">
      <b-col class="reduce-padding" cols="12">
        <wlpHeader :pageTitle="pageTitle"></wlpHeader>
      </b-col>
      <b-col class="page-background-gradient reduce-padding" cols="12">
        <b-row class="page-content no-gutters">
          <b-row class="body-sec no-gutters">
            <b-col class="left-col" lg="6">
              <div class="inner-col">
                <div class="first-row">
                  <div class="ques-row">
                    <div class="number-icon"></div>
                    <div
                      class="ques-desc"
                      :class="{ 'ques-desc-sp': $i18n.locale == 'sp' }"
                    >
                      {{ $t("Menu.ques-desc-1") }}
                    </div>
                  </div>
                  <div class="units-row">
                    <div class="flag-icon"></div>
                    <div class="wlp-radio">
                      <input
                        type="radio"
                        name="englishSystem"
                        v-model="userData.unitsSystem"
                        id="englishSystem"
                        value="englishSystem"
                        @change="unitsUpdate()"
                      />
                      <label class="" for="englishSystem">
                        <div class="checkbox-label">
                          {{ $t("Menu.englishSystem") }}
                          <span class="unbold">
                            {{ $t("Menu.englishUnit") }}</span
                          >
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="units-row top-margin">
                    <div class="m-icon"></div>
                    <div class="wlp-radio metric-radios">
                      <input
                        type="radio"
                        name="metricSystem"
                        v-model="userData.unitsSystem"
                        id="metricSystem"
                        value="metricSystem"
                        @change="unitsUpdate()"
                      />
                      <label class="" for="metricSystem">
                        <div class="checkbox-label">
                          {{ $t("Menu.metricSystem") }}
                          <span class="unbold">
                            {{ $t("Menu.metricUnit") }}</span
                          >
                        </div>
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
                <div class="fields-row">
                  <!--weight-->
                  <b-row class="no-gutters">
                    <b-col cols="12">
                      <div
                        class="fields-div"
                        :class="{
                          haserror:
                            submitted &&
                            (!$v.userData.weight.required ||
                              !$v.userData.weight.numeric ||
                              !$v.userData.weight.minLength ||
                              !$v.userData.weight.maxLength),
                        }"
                      >
                        <input
                          class="fields"
                          type="text"
                          maxLength="3"
                          name="weight"
                          v-model.number="userData.weight"
                          id="weight"
                          @change="inputChange()"
                        />
                        <div class="fields-labels">
                          {{ $t("common.weight") }}
                          <span class="units-label">
                            <span
                              v-if="userData.unitsSystem === 'englishSystem'"
                              :class="{ 'units-sp': $i18n.locale == 'sp' }"
                              >(lb)</span
                            >
                            <span
                              v-if="userData.unitsSystem === 'metricSystem'"
                              :class="{ 'units-sp': $i18n.locale == 'sp' }"
                              >(kg)</span
                            >
                          </span>
                        </div>
                        <div
                          class="error-msg"
                          :class="{
                            'error-msg-sp': $i18n.locale == 'sp',
                            'error-msg-sp': $i18n.locale == 'sp',
                          }"
                          v-if="
                            userData.unitsSystem === 'metricSystem' &&
                            ((submitted &&
                              (!$v.userData.weight.required ||
                                !$v.userData.weight.numeric ||
                                !$v.userData.weight.minLength ||
                                !$v.userData.weight.maxLength)) ||
                              (submitted &&
                                (this.userData.weight < 32 ||
                                  this.userData.weight > 272)))
                          "
                        >
                          {{ $t("Menu.error-weight") }} <span>32-272 kg.</span>
                        </div>

                        <div
                          class="error-msg weight-lb"
                          :class="{
                            'error-msg-sp': $i18n.locale == 'sp',
                            'error-msg-sp': $i18n.locale == 'sp',
                          }"
                          v-if="
                            userData.unitsSystem === 'englishSystem' &&
                            ((submitted &&
                              (!$v.userData.weight.required ||
                                !$v.userData.weight.numeric ||
                                !$v.userData.weight.minLength ||
                                !$v.userData.weight.maxLength)) ||
                              (submitted &&
                                (this.userData.weight < 70 ||
                                  this.userData.weight > 600)))
                          "
                        >
                          {{ $t("Menu.error-weight") }}
                          <span>70-600 lb.</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <!--height-->
                  <b-row class="no-gutters top-margin-row">
                    <b-col cols="12">
                      <div
                        class="fields-div"
                        :class="{
                          haserror:
                            submitted &&
                            (!$v.userData.height.required ||
                              !$v.userData.height.numeric ||
                              !$v.userData.height.minLength ||
                              !$v.userData.height.maxLength ||
                              !$v.userData.height.between),
                        }"
                      >
                        <input
                          class="fields"
                          type="text"
                          maxLength="3"
                          name="height"
                          v-model.number="userData.height"
                          id="height"
                          @change="inputChange()"
                        />
                        <div class="fields-labels">
                          {{ $t("common.height") }}
                          <span class="units-label">
                            <span
                              v-if="userData.unitsSystem === 'englishSystem'"
                              :class="{ 'units-sp': $i18n.locale == 'sp' }"
                              >({{ $t("common.inches") }})</span
                            >
                            <span
                              v-if="userData.unitsSystem === 'metricSystem'"
                              :class="{ 'units-sp': $i18n.locale == 'sp' }"
                              >(cm)</span
                            >
                          </span>
                        </div>
                        <div
                          class="error-msg height-cm"
                          :class="{
                            'error-msg-sp': $i18n.locale == 'sp',
                            'error-msg-sp': $i18n.locale == 'sp',
                          }"
                          v-if="
                            userData.unitsSystem === 'metricSystem' &&
                            ((submitted &&
                              (!$v.userData.height.required ||
                                !$v.userData.height.numeric ||
                                !$v.userData.height.minLength ||
                                !$v.userData.height.maxLength)) ||
                              (submitted &&
                                (this.userData.height < 122 ||
                                  this.userData.height > 224)))
                          "
                        >
                          {{ $t("Menu.error-height") }} <span>122-224 cm.</span>
                        </div>

                        <div
                          class="error-msg height-in"
                          :class="{
                            'error-msg-sp': $i18n.locale == 'sp',
                            'error-msg-sp': $i18n.locale == 'sp',
                          }"
                          v-if="
                            userData.unitsSystem === 'englishSystem' &&
                            ((submitted &&
                              (!$v.userData.height.required ||
                                !$v.userData.height.numeric ||
                                !$v.userData.height.minLength ||
                                !$v.userData.height.maxLength)) ||
                              (submitted &&
                                (this.userData.height < 48 ||
                                  this.userData.height > 88)))
                          "
                        >
                          {{ $t("Menu.error-height") }}
                          <span>48-88 inches.</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <!--age-->
                  <b-row class="no-gutters top-margin-row age-row">
                    <b-col cols="12">
                      <div
                        class="fields-div"
                        :class="{
                          haserror:
                            submitted &&
                            (!$v.userData.age.required ||
                              !$v.userData.age.numeric ||
                              !$v.userData.age.minLength ||
                              !$v.userData.age.maxLength ||
                              !$v.userData.age.between),
                          'haserror-sp': $i18n.locale == 'sp',
                        }"
                      >
                        <input
                          class="fields"
                          type="text"
                          maxLength="3"
                          name="age"
                          v-model.number="userData.age"
                          id="age"
                          @change="inputChange()"
                        />
                        <div class="fields-labels">
                          {{ $t("common.age") }}
                        </div>
                        <div
                          class="error-msg age-width"
                          :class="{
                            'age-width-sp': $i18n.locale == 'sp',
                            'error-msg-sp': $i18n.locale == 'sp',
                          }"
                          v-if="
                            submitted &&
                            (!$v.userData.age.required ||
                              !$v.userData.age.numeric ||
                              !$v.userData.age.minLength ||
                              !$v.userData.age.maxLength ||
                              !$v.userData.age.between)
                          "
                        >
                          {{ $t("Menu.error-age") }}.
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <!--gender-->
                  <b-row class="no-gutters top-margin-row gender-row">
                    <b-col cols="12">
                      <div
                        class="fields-div-radios"
                        :class="{
                          haserror: submitted && !$v.userData.gender.required,
                        }"
                      >
                        <div class="wlp-radio">
                          <input
                            type="radio"
                            name="male"
                            v-model="userData.gender"
                            value="Male"
                            id="male"
                            @change="genderChange()"
                          />
                          <label class="no-label" for="male">
                            <div class="fields-labels-radios">
                              {{ $t("common.male") }}
                            </div>
                          </label>
                        </div>

                        <div
                          class="wlp-radio female-radio"
                          :class="{ 'female-radio-sp': $i18n.locale == 'sp' }"
                        >
                          <input
                            type="radio"
                            name="female"
                            v-model="userData.gender"
                            id="female"
                            value="Female"
                            @change="genderChange()"
                          />
                          <label class="no-label" for="female">
                            <div class="fields-labels-radios">
                              {{ $t("common.female") }}
                            </div>
                          </label>
                        </div>
                        <div
                          class="error-radios"
                          :class="{
                            'error-radios-sp': $i18n.locale == 'sp',
                            'error-msg-sp': $i18n.locale == 'sp',
                            'error-msg': $i18n.locale == 'en',
                          }"
                          v-if="submitted && !$v.userData.gender.required"
                        >
                          {{ $t("Menu.error-required") }}
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <hr />
                <div class="bmi-row">
                  <div class="bmi-txt">{{ $t("Menu.bmitxt") }}</div>
                  <div class="bmi-txtbox">
                    <span v-if="!(userData.bmi > 0 && userData.bmi < 100)"
                      >-</span
                    >
                    <span v-if="userData.bmi > 0 && userData.bmi < 100">{{
                      userData.bmi
                    }}</span>
                  </div>
                </div>
              </div>
            </b-col>

            <b-col class="right-col" lg="6">
              <hr class="verticle-hr" />
              <div class="main-left-area">
                <div class="ques2row">
                  <div class="ques-row">
                    <div class="number-icon2"></div>
                    <div
                      class="ques-desc"
                      :class="{ 'ques-desc-sp': $i18n.locale == 'sp' }"
                    >
                      {{ $t("Menu.ques-desc-2") }}
                      <span class="unbold">{{ $t("Menu.ques-desc-2-1") }}</span>
                    </div>
                  </div>
                </div>

                <div class="checkboxes-main-sec">
                  <b-row class="no-gutters">
                    <b-col cols="12">
                      <div class="ribbon-icon"></div>
                      <div class="wlp-checkboxes">
                        <div
                          @click="navigateTo('cancer')"
                          class="clickable unchecked-img"
                          :class="{
                            'checkbox-img': userData.sectionFlags.cancer,
                          }"
                        ></div>
                        <div class="checkbox-label-outer">
                          <div
                            @click="navigateTo('cancer')"
                            class="clickable checkbox-label-new"
                          >
                            {{ $t("common.cancer") }}
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="no-gutters">
                    <b-col cols="12">
                      <div class="hyperlipidemia-icon"></div>
                      <div class="wlp-checkboxes">
                        <div
                          @click="navigateTo('dyslipidemia')"
                          class="unchecked-img clickable"
                          :class="{
                            'checkbox-img': userData.sectionFlags.hyplip,
                          }"
                        ></div>
                        <div class="checkbox-label-outer">
                          <div
                            @click="navigateTo('dyslipidemia')"
                            class="checkbox-label-new clickable"
                          >
                            {{ $t("common.dyslipidemia") }}
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="no-gutters">
                    <b-col cols="12">
                      <div class="hypertension-icon"></div>
                      <div class="wlp-checkboxes">
                        <div
                          @click="navigateTo('hypertension')"
                          class="unchecked-img clickable"
                          :class="{
                            'checkbox-img': userData.sectionFlags.hypten,
                          }"
                        ></div>
                        <div class="checkbox-label-outer">
                          <div
                            @click="navigateTo('hypertension')"
                            class="checkbox-label-new clickable"
                          >
                            {{ $t("common.hypertension") }}
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="no-gutters">
                    <b-col
                      cols="12"
                      :class="{ 'opacity-div': userData.gender == 'Male' }"
                    >
                      <div class="infertility-icon"></div>
                      <div class="wlp-checkboxes">
                        <div
                          class="unchecked-img clickable"
                          :class="{
                            'checkbox-img': userData.sectionFlags.infertility,
                          }"
                          @click="navigateTo('pcos')"
                        ></div>
                        <div class="checkbox-label-outer">
                          <div
                            class="checkbox-label-new clickable"
                            @click="navigateTo('pcos')"
                          >
                          Infertility (PCOS)
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <!-- <b-row class="no-gutters">
                    <b-col cols="12">
                      <div class="nafld-icon"></div>
                      <div class="wlp-checkboxes">
                        <div
                          @click="navigateTo('nafld')"
                          class="unchecked-img clickable"
                          :class="{
                            'checkbox-img': userData.sectionFlags.nafld,
                          }"
                        ></div>
                        <div class="checkbox-label-outer">
                          <div
                            @click="navigateTo('nafld')"
                            class="checkbox-label-new clickable"
                          >
                            {{ $t("common.NAFLD") }}
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row> -->

                  <b-row class="no-gutters">
                    <b-col cols="12">
                      <div class="osteoarthritis-icon"></div>
                      <div class="wlp-checkboxes">
                        <div
                          @click="navigateTo('osteoarthritis')"
                          class="unchecked-img clickable"
                          :class="{
                            'checkbox-img': userData.sectionFlags.osteoarth,
                          }"
                        ></div>
                        <div class="checkbox-label-outer">
                          <div
                            @click="navigateTo('osteoarthritis')"
                            class="checkbox-label-new clickable"
                          >
                            {{ $t("common.osteoarthritis") }}
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="no-gutters">
                    <b-col cols="12">
                      <div class="type2-icon"></div>
                      <div class="wlp-checkboxes">
                        <div
                          @click="navigateTo('type2Diabetes')"
                          class="unchecked-img clickable"
                          :class="{
                            'checkbox-img': userData.sectionFlags.diab,
                          }"
                        ></div>
                        <div class="checkbox-label-outer">
                          <div
                            @click="navigateTo('type2Diabetes')"
                            class="checkbox-label-new clickable"
                          >
                            {{ $t("common.diabetes") }}
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="no-gutters">
                    <b-col cols="12">
                      <div class="yearsLost-icon"></div>
                      <div class="wlp-checkboxes">
                        <div
                          @click="navigateTo('lifeLost')"
                          class="unchecked-img clickable"
                          :class="{
                            'checkbox-img': userData.sectionFlags.yearsLost,
                          }"
                        ></div>
                        <div class="checkbox-label-outer">
                          <div
                            @click="navigateTo('lifeLost')"
                            class="checkbox-label-new clickable"
                          >
                            {{ $t("Menu.lifeLost") }}
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-row>
        <wlpNavigation
          :navButtons="['info', 'references', 'tnc', 'summary', 'back', 'next']"
          :btnClickHandler="this.handleSubmit"
          :currentScreen="2"
        ></wlpNavigation>
      </b-col>
    </b-col>
  </b-row>
</template>

<script>
import scrollMixin from "../mixins/scrollMixin";
import calcManager from "../mixins/calculations/calcManager";
import wlpNavigation from "../components/wlpNavigation.vue";
import wlpHeader from "../components/wlpHeader.vue";
import { mapGetters, mapMutations } from "vuex";
import {
  required,
  maxLength,
  numeric,
  minLength,
  between,
} from "vuelidate/lib/validators";

export default {
  name: "menuPage",
  mixins: [scrollMixin, calcManager],
  components: {
    wlpHeader: wlpHeader,
    wlpNavigation: wlpNavigation,
  },

  data() {
    return {
      pageTitle: this.$t("Menu.pageTitle"),
      submitted: false,
      cm: 0,
      kgs: 0,
    };
  },

  computed: {
    ...mapGetters("userData", ["userData"]),
  },

  mounted: function () {
    if (
      this.userData.unitsSystem == "englishSystem" &&
      this.userData.height == "" &&
      this.userData.weight == ""
    ) {
      if (this.$i18n.locale == "en") {
        this.userData.unitsSystem = "englishSystem";
      } else if (this.$i18n.locale == "sp") {
        this.userData.unitsSystem = "metricSystem";
      }
    }
    this.scrollToTop();
  },

  validations: {
    userData: {
      weight: {
        required,
        numeric,
        minLength: minLength(2),
        maxLength: maxLength(3),
        // between: between(69, 601)
      },

      height: {
        required,
        numeric,
        minLength: minLength(2),
        maxLength: maxLength(3),
        // between: between(48, 88)
      },

      age: {
        required,
        numeric,
        minLength: minLength(2),
        maxLength: maxLength(2),
        between: between(20, 79),
      },
      gender: {
        required,
      },
    },
  },

  methods: {
    ...mapMutations("userData", ["resetConditions"]),
    isBmiDataValid: function () {
      if (this.userData.unitsSystem == "englishSystem") {
        return (
          this.userData.weight >= 70 &&
          this.userData.weight <= 600 &&
          this.userData.height >= 48 &&
          this.userData.height <= 88
        );
      } else {
        return (
          this.userData.weight >= 32 &&
          this.userData.weight <= 272 &&
          this.userData.height >= 122 &&
          this.userData.height <= 224
        );
      }
    },

    isDataValid: function () {
      return (
        this.isBmiDataValid() &&
        this.userData.age >= 20 &&
        this.userData.age <= 79 &&
        this.userData.gender !== ""
      );
    },

    unitsUpdate: function () {
      this.userData.height = "";
      this.userData.weight = "";

      //clear out all progress if units are changed
      this.userData.sbp = "";
      this.userData.dbp = "";

      // clear out derived values
      this.updateBmi(false);
    },

    inputChange: function () {
      this.updateBmi(this.isBmiDataValid()); //include valid data check

      //Calculate risk values if valid
      this.updateRisk(this.isDataValid()); //include valid data check
    },
    genderChange: function () {
      this.resetConditions({ section: "infertility" });
      this.inputChange();
    },

    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.userData.unitsSystem == "englishSystem") {
        if (
          this.userData.weight < 70 ||
          this.userData.weight > 600 ||
          this.$v.$invalid
        ) {
          this.scrollToError();
          return false;
        }
        if (
          this.userData.height < 48 ||
          this.userData.height > 88 ||
          this.$v.$invalid
        ) {
          this.scrollToError();
          return false;
        }
      } else if (this.userData.unitsSystem == "metricSystem") {
        if (
          this.userData.weight < 32 ||
          this.userData.weight > 272 ||
          this.$v.$invalid
        ) {
          this.scrollToError();
          return false;
        }
        if (
          this.userData.height < 122 ||
          this.userData.height > 224 ||
          this.$v.$invalid
        ) {
          this.scrollToError();
          return false;
        }
      }

      return true;
    },

    navigateTo: function (screen) {
      if (
        this.handleSubmit() &&
        !(screen == "pcos" && this.userData.gender == this.$t("common.male"))
      ) {
        this.$router.push(screen);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
